"use client";

import { defaultBaseConfig } from "@chakra-ui/react/preset-base";
import {
  ChakraProvider,
  createSystem,
  defineConfig,
} from "@chakra-ui/react/styled-system";
import FuzeyTheme from "theme";
import defaultTheme from "theme/defaultTheme";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";
import { Toaster } from "./toaster";

// Global default colorPalette is gray. The merchant's brand colorScheme
// is opted into per-surface via `colorPalette={brandColor}` on primary
// buttons, links, focus rings, and active nav items - everywhere else
// stays neutral. Read brandColor from Redux at the call site:
//   const brandColor = useAppSelector((s) => s.theme.colorScheme);
const fuzeySystem = createSystem(
  defaultBaseConfig,
  defaultTheme,
  FuzeyTheme,
  defineConfig({
    globalCss: {
      html: {
        colorPalette: "gray",
      },
    },
  })
);

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={fuzeySystem}>
      <Toaster />
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
